<!-- 标题配置 -->
<template>
    <div class="config-box">
        <el-form-item label="文本" label-width="80">
            <FontSet renderType="color, size, isBold, isItalic, align" v-model="titleFontSet"></FontSet>
        </el-form-item>
        <el-form-item label="副标题" label-width="80">
            <FontSet renderType="color, size, isBold, isItalic, align" v-model="subTitleFontSet"></FontSet>
        </el-form-item>
        <el-form-item label="背景色" label-width="80">
            <el-color-picker
                size="small"
                show-alpha
                v-model="backgroundColor"
            />
        </el-form-item>
    </div>
</template>
  
<script>
import FontSet from './fontSet.vue'

export default {
    name: "titleConfig",
    data() {
        return {
            titleFontSet: this.modelValue?.titleFontSet,
            subTitleFontSet: this.modelValue?.subTitleFontSet,
            backgroundColor: this.modelValue?.backgroundColor,
        }
    },
    props: {
        modelValue: {
            type: Object,
            default: () => {
                return {
                    titleFontSet: {},
                    subTitleFontSet: {},
                    backgroundColor: '',
                }
            }
        },
    },
    watch: {
        titleFontSet: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    titleFontSet: val,
                })
            },
        },
        subTitleFontSet: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    subTitleFontSet: val,
                })
            },
        },
        backgroundColor(val) {
            this.$emit('update:modelValue', {
                ...this.modelValue,
                backgroundColor: val,
            })
        },
    },
    components: {
        FontSet,
    },
    mounted() {
    },
    methods: {
    }
};
</script>
  
<style lang="scss" scoped>
.config-box {
    padding: 5px 0;
}
</style>